// src/features/auth/useIsAuthor.ts
import { useMe } from './useMe'
import { useAppSelector } from '@/store/hooks'

export const useIsAuthor = () => {
  const { data, isLoading } = useMe()
  const forceIsAuthor = useAppSelector((s) => s.dev.forceIsAuthor)
  const forceIsAdmin = useAppSelector((s) => s.dev.forceIsAdmin)

  const baseline = (data?.isAuthor ?? false) || (data?.isAdmin ?? false)
  const isAuthor = import.meta.env.DEV && (forceIsAuthor || forceIsAdmin) ? true : baseline
  return { isAuthor, isLoading }
}
